namespace Solovis.Properties.PropertyEditor {

    export function addPropertyToResource(options) {
        var resourceId = options.resourceId;

        // saveCallback should be a function with no args that is called if a property modification is made.
        var saveCallback = options.saveCallback ? options.saveCallback : null;

        var formDiv = $("<div>");

        var propDefSelectorDiv = $("<div>").css("min-height", "100px").appendTo(formDiv);

        var propDefSelectorControl = null;

        var dialog = new Solovis.UI.Dialog({
            container: formDiv,

            title: "Add Property",
            autoOpen: true,
            width: 700,
            height: 500,
            center: true,
            modal: true,
            destroyOnClose: true,
            actions: ["Close"],

            buttons: [
                {
                    label: "Cancel",
                    click: function () {
                        dialog.close();
                    }
                }
            ],

            open: function () {
                var editorLoaderControl = new Solovis.UI.DynamicLoadPlaceholderControl({
                    controlHost: propDefSelectorDiv,

                    requiredModules: ["Solovis.PropertyEditor"],

                    controlTypeName: "Solovis.Properties.Editors.PropertyDefinitionToAddSelector",
                    newControlOptions: {
                        resourceId: resourceId,
                        selectionCallback: function (property) {
                            dialog.close();
                            (Solovis as any).Properties.PropertyEditor.editResourceProperty({
                                resourceId: resourceId,
                                property: property,

                                saveCallback: saveCallback
                            });
                        }
                    }
                });

                editorLoaderControl.setAsCurrentControl();
            }
        });
    }

    export function editResourceProperty(options) {
        var editorOptions: any = {
        };

        if (options.resourceId) {
            editorOptions.resourceId = options.resourceId;
        }

        if (options.property) {
            editorOptions.property = options.property;
        }

        if (options.propertyDefinitionId) {
            editorOptions.propertyDefinitionId = options.propertyDefinitionId;
        }

        if (options.propertyTypeId) {
            editorOptions.propertyTypeId = options.propertyTypeId;
        }

        if (Solovis.isNotNull(options.from)) {
            editorOptions.from = options.from;
        }

        // saveCallback should be a function with no args that is called if a property modification is made for a specific resource.
        // If no resource is specified, saveCallback will be passed on argument for setValueOptions (which is used from BulkPropertyEditor).
        var saveCallback = options.saveCallback ? options.saveCallback : null;


        var dialog = null;

        var formDiv = $("<div>");

        // adding height only for html property so the html editor can resize with the modal
        if (editorOptions.property && editorOptions.property.propertyTypeId && editorOptions.property.propertyTypeId === 7
            || editorOptions.propertyTypeId == 7) {
            formDiv.css("height", "85%");
        }

        var propEditorDiv = $("<div>").css("min-height", "100px").css("height", "100%").appendTo(formDiv);
        var propEditorControlHost = new Solovis.UI.ControlHost({ container: propEditorDiv });

        var dialogButtons = [];

        dialogButtons.push({
            label: "Save",
            click: function () {
                var propEditorControl = null;
                var currentControl = propEditorControlHost.currentControl.propEditorControl;
                if (currentControl) {
                    propEditorControl = currentControl;
                }

                if (propEditorControl) {
                    var propDefId = propEditorControl.getPropertyDefinitionId();
                    var newFromDayId = propEditorControl.getFromDayId();
                    var values = propEditorControl.getValues();

                    var setValueOptions: any = {
                        propertyDefinitionId: propDefId,
                        values: values,
                        fromDayId: newFromDayId
                    };

                    if (options.resourceId) {
                        var resourceId = options.resourceId;

                        setValueOptions.resourceId = resourceId;

                        if (!propEditorControl.shouldCreateNewSinceDate()) {
                            // If we don't want to force creation of new since date, we will remove old date when we save this value.
                            if (options.from != newFromDayId) {
                                setValueOptions.replaceFromDayId = options.from;
                            }
                        }

                        Solovis.Rpc.invokeAndWait(
                            "~/Rpc/PropertyEdit/SetValues",
                            { valuesToEdit: [setValueOptions] },
                            function (response, success) {
                                if (success) {
                                    dialog.close();

                                    if (saveCallback) {
                                        saveCallback();
                                    }
                                }
                            });
                    }
                    else {
                        dialog.close();

                        if (saveCallback) {
                            saveCallback(setValueOptions);
                        }
                    }
                }
            }
        });

        if (Solovis.isNotNull(editorOptions.from)) {
            dialogButtons.push({
                label: "Delete",
                click: function () {
                    var fromStr = editorOptions.from ? Solovis.getGlobalObject().InvData.Util.DateIndexHelper.formatDateIndexAsDateString(editorOptions.from) : "Always";
                    Solovis.UI.confirm("Delete value for " + fromStr + "?", "Delete Value", function (confirmed) {
                        if (confirmed) {
                            var propEditorControl = null;
                            var currentControl = propEditorControlHost.currentControl.propEditorControl;
                            if (currentControl) {
                                propEditorControl = currentControl;

                                var propDefId = propEditorControl.getPropertyDefinitionId();

                                Solovis.Rpc.invokeAndWait(
                                    "~/Rpc/PropertyEdit/DeleteValues",
                                    {
                                        valuesToDelete: [
                                            { resourceId: editorOptions.resourceId, propertyDefinitionId: propDefId, fromDayId: editorOptions.from }
                                        ]
                                    },
                                    function (response, success) {
                                        if (success) {
                                            dialog.close();

                                            if (saveCallback) {
                                                saveCallback(null);
                                            }
                                        }
                                    });
                            }
                        }
                    });
                }
            });
        }

        dialogButtons.push({
            label: "Cancel",
            click: function () {
                dialog.close();
            }
        });

        dialog = new Solovis.UI.Dialog({
            container: formDiv,

            title: "Edit Property",
            autoOpen: true,
            center: true,
            width: 700,
            height: 500,
            modal: true,
            buttons: dialogButtons,
            actions: ["Close"],

            destroyOnClose: true,

            activate: function () {
              var editorLoaderControl = new (Solovis as any).Properties.PropertyEditorDialog({
                controlHost: propEditorControlHost,
                editorOptions: editorOptions
              });

              editorLoaderControl.setAsCurrentControl();
            },
            close: function () {
              if (($("#tiny-editor") as any).tinymce()) {
                // Removed html editor when closing modal because html editor was not showing up after closing then reopening property editor modal.  
                ($("#tiny-editor") as any).tinymce().remove();
              }
            }
          });
    }


    export function deleteResourcePropertyValue(options) {
        var deleteOptions: any = {
        };

        deleteOptions.resourceId = options.resourceId;
        deleteOptions.propertyDefinitionId = options.property.id;
        deleteOptions.fromDayId = options.from;

        // saveCallback should be a function with no args that is called if a property modification is made.
        var saveCallback = options.saveCallback ? options.saveCallback : null;

        var deletePrompt = $("<div>");
        deletePrompt.append("Delete value for property ");
        deletePrompt.append($("<span>").text(options.property.label));
        deletePrompt.append("?");

        Solovis.UI.confirm(deletePrompt, "Delete Property Value",
            function (confirmed) {
                if (confirmed) {
                    Solovis.Rpc.invokeAndWait(
                        "~/Rpc/PropertyEdit/DeleteValues",
                        { valuesToDelete: [deleteOptions] },
                        function () {
                            if (saveCallback) {
                                saveCallback();
                            }
                        });
                }
            });
    }
}

namespace Solovis.Properties {

    export class PropertyEditorDialog extends Solovis.UI.BaseControl {

        public editorOptions;
        public propEditorControl;


        constructor(options) {
            super(options);

            this.editorOptions = options.editorOptions;
        }

        public static requiredModules = ["Solovis.PropertyEditor"];

        public doRender() {
            var propEditorDiv = $("<div>").appendTo(this.container).css("height", "100%");

            var propEditorControlHost = new Solovis.UI.ControlHost({ container: propEditorDiv });

            this.propEditorControl = new (Solovis as any).Properties.Editors.PropertyEditorControl(this.editorOptions);
            propEditorControlHost.setCurrentControl(this.propEditorControl);
        }
    }

}